import { SupportedLanguageSchema } from '@geartracker/types';

import { createZodDto } from './zod';

import { z } from 'zod';

const distributorCreateOrganizationSchema = z.object({
  name: z.string().trim().min(1).max(200),
  equipmentLimit: z.number().int().positive(),
  admin: z.object({
    firstName: z.string().trim().min(1).max(200),
    lastName: z.string().trim().min(1).max(200),
    phone: z.string().trim().max(50).nullable().optional(),
    email: z.string().trim().toLowerCase().pipe(z.email()),
    language: SupportedLanguageSchema,
  }),
});

export class DistributorCreateOrganizationDto extends createZodDto(
  distributorCreateOrganizationSchema,
) {}

const distributorUpdateOrganizationSchema = z.object({
  name: z.string().trim().min(1).max(200).optional(),
  equipmentLimit: z.number().int().positive().nullable().optional(),
});

export class DistributorUpdateOrganizationDto extends createZodDto(
  distributorUpdateOrganizationSchema,
) {}

const distributorUpdateUserSchema = z.object({
  firstName: z.string().min(1).max(200).optional(),
  lastName: z.string().min(1).max(200).optional(),
  email: z.email().nullable().optional(),
  role: z
    .enum(['ADMIN', 'EDITOR', 'REVIEWER', 'READER', 'HOLDER', 'NONE'])
    .optional(),
  isDeactivated: z.boolean().optional(),
});

export class DistributorUpdateUserDto extends createZodDto(
  distributorUpdateUserSchema,
) {}
